module.exports = __webpack_public_path__ + "static/media/portable_toilette.ef67bf49.svg";